(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luminoire-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luminoire-reels')) {
  customElements.define('luminoire-reels', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cards = [...this.querySelectorAll('[data-reels-card]')];
      this.viewer = this.querySelector('[data-reels-viewer]');
      this.player = this.querySelector('[data-reels-player]');
      this.track = this.querySelector('[data-reels-track]');
      this.index = 0;
      this.mode = 'closed';
      this.muted = false;
      const on = (node, type, handler, options = {}) => node?.addEventListener(type, handler, {...options, signal});
      const control = (name, handler) => on(this.querySelector(`[data-reels-${name}]`), 'click', handler);
      this.visibleCards = () => this.cards.filter(card => card.getClientRects().length);
      this.cards.forEach(card => {
        const preview = card.querySelector('video');
        card.dataset.desktopPoster = preview.poster;
      });
      const updatePosters = () => this.cards.forEach(card => {
        const poster = matchMedia('(max-width:749px)').matches && card.dataset.mobilePoster ? card.dataset.mobilePoster : card.dataset.desktopPoster;
        card.querySelector('video').poster = poster;
      });
      updatePosters();
      on(window, 'resize', updatePosters);
      on(this, 'shopify:block:select', event => {
        const card = event.target.closest('.lst-reels__card');
        if (card) this.track.scrollTo({left:card.offsetLeft - this.track.offsetLeft, behavior:'smooth'});
      });
      this.cards.forEach(card => on(card, 'click', () => {
        this.returnFocus = card;
        this.open();
        this.select(this.visibleCards().indexOf(card));
      }));
      control('minimize', () => this.minimize());
      control('close', () => this.close());
      control('expand', () => this.open());
      control('backdrop', () => this.minimize());
      control('previous', () => this.select(this.index - 1));
      control('next', () => this.select(this.index + 1));
      control('sound', () => { this.muted = !this.player.muted; this.player.muted = this.muted; this.updateSound(); });
      control('add', () => {
        const form = this.closest('[data-lst-product]')?.querySelector('.lst-product-form');
        const submit = form?.querySelector('[data-lst-atc]');
        if (!submit || submit.disabled) return;
        this.minimize();
        form.requestSubmit(submit);
      });
      control('back', () => this.track.scrollBy({left: -this.track.clientWidth, behavior: 'smooth'}));
      control('more', () => this.track.scrollBy({left: this.track.clientWidth, behavior: 'smooth'}));
      const updateTrack = () => {
        this.querySelector('[data-reels-back]').disabled = this.track.scrollLeft <= 2;
        this.querySelector('[data-reels-more]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        const count = this.querySelector('[data-reels-count]');
        count.textContent = count.textContent.replace(/\d+/, this.visibleCards().length);
      };
      on(this.track, 'scroll', updateTrack, {passive:true});
      this.resizeObserver = new ResizeObserver(updateTrack);
      this.resizeObserver.observe(this.track);
      on(this.player, 'click', () => {
        if (this.swiped) { this.swiped = false; return; }
        if (this.mode === 'mini') this.open();
        else if (this.player.paused) this.play();
        else this.player.pause();
      });
      on(this.player, 'ended', () => this.select((this.index + 1) % this.visibleCards().length));
      on(this.player, 'touchstart', event => {
        this.touch = {x:event.touches[0].clientX, y:event.touches[0].clientY};
        this.swiped = false;
      }, {passive:true});
      on(this.player, 'touchend', event => {
        if (!this.touch) return;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        this.touch = null;
        if (Math.abs(dy) > 45 && Math.abs(dy) > Math.abs(dx)) {
          this.swiped = true;
          this.select(this.index + (dy < 0 ? 1 : -1));
        }
      }, {passive:true});
      on(this.viewer, 'wheel', event => {
        event.preventDefault();
        if (Math.abs(event.deltaY) < 12 || Date.now() - (this.lastWheel || 0) < 500) return;
        this.lastWheel = Date.now();
        this.select(this.index + (event.deltaY > 0 ? 1 : -1));
      }, {passive:false});
      on(this.viewer, 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.mode === 'full' ? this.minimize() : this.close(); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); this.select(this.index + (event.key === 'ArrowDown' ? 1 : -1)); }
        if ((event.key === ' ' || event.key === 'Enter') && event.target === this.player) { event.preventDefault(); this.player.click(); }
        if (event.key === 'Tab' && this.mode === 'full') {
          const focusable = [...this.viewer.querySelectorAll('button:not(:disabled),[tabindex="0"]')].filter(el => el.getClientRects().length);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      on(document, 'visibilitychange', () => {
        if (document.hidden) { this.wasPlaying = !this.player.paused; this.player.pause(); this.cards.forEach(card => card.querySelector('video').pause()); }
        else if (this.mode !== 'closed' && this.wasPlaying) this.play();
      });
      this.previewObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (entry.isIntersecting && this.mode === 'closed' && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
        else video.pause();
      }), {threshold:.6});
      this.cards.forEach(card => this.previewObserver.observe(card));
    }
    updateSound() { this.querySelector('[data-reels-sound]').setAttribute('aria-pressed', String(this.player.muted)); }
    play() {
      this.player.play().catch(() => {
        if (this.mode === 'closed') return;
        this.player.muted = this.muted = true;
        this.updateSound();
        this.player.play().catch(() => {});
      });
    }
    select(index) {
      const cards = this.visibleCards();
      if (index < 0 || index >= cards.length) return;
      this.index = index;
      this.player.src = cards[index].dataset.src;
      this.player.poster = cards[index].querySelector('video').poster;
      this.player.style.objectFit = cards[index].style.getPropertyValue('--reels-fit') || 'cover';
      this.player.muted = this.muted;
      this.querySelector('[data-reels-position]').textContent = `${index + 1} / ${cards.length}`;
      this.querySelector('[data-reels-previous]').disabled = index === 0;
      this.querySelector('[data-reels-next]').disabled = index === cards.length - 1;
      this.updateSound();
      this.play();
    }
    open() {
      this.viewer.hidden = false;
      this.viewer.classList.remove('is-mini');
      this.viewer.setAttribute('aria-modal','true');
      this.mode = 'full';
      document.documentElement.classList.add('lst-reels-open');
      this.cards.forEach(card => card.querySelector('video').pause());
      this.querySelector('[data-reels-minimize]').focus({preventScroll:true});
    }
    minimize() {
      this.mode = 'mini';
      this.viewer.classList.add('is-mini');
      this.viewer.removeAttribute('aria-modal');
      document.documentElement.classList.remove('lst-reels-open');
      this.returnFocus?.focus({preventScroll:true});
    }
    close() {
      this.mode = 'closed';
      this.player.pause();
      this.viewer.hidden = true;
      document.documentElement.classList.remove('lst-reels-open');
      this.returnFocus?.focus({preventScroll:true});
      this.cards.forEach(card => { this.previewObserver.unobserve(card); this.previewObserver.observe(card); });
    }
    disconnectedCallback() {
      this.player?.pause();
      this.cards?.forEach(card => card.querySelector('video').pause());
      this.controller?.abort();
      this.controller = null;
      this.previewObserver?.disconnect();
      this.resizeObserver?.disconnect();
      document.documentElement.classList.remove('lst-reels-open');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
